import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { intlMessageShape } from 'sb-react-intl'

import Button from 'components/buttons/Button/Button'


const generateButton = ({ displayName, action, defaultTitle, withLoading, onClick: generateOnClick }) =>

  class AddTo extends Component {

    static displayName = displayName

    static propTypes = {
      component: PropTypes.elementType,
      title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape(intlMessageShape),
      ]),
      product: PropTypes.shape({
        id: PropTypes.number.isRequired,
        isLimitedEdition: PropTypes.bool,
        tradingId: PropTypes.number,
        price: PropTypes.number,
        upchargePrice: PropTypes.number,
        name: PropTypes.string,
        brand: PropTypes.string,
        img: PropTypes.string,
        volume: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
        volumeUnit: PropTypes.string,
        productGroup: PropTypes.string,
      }).isRequired,
      metadata: PropTypes.object.isRequired,
      snowplowMetadata: PropTypes.object,
      onClick: PropTypes.func,
      onBeforeAdd: PropTypes.func,
      onAfterAdd: PropTypes.func,
    }

    static defaultProps = {
      title: defaultTitle,
      snowplowMetadata: {},
    }

    state = {
      isFetching: false,
    }

    handleClick = (event) => {
      const { isFetching } = this.state
      const { product, metadata, onBeforeAdd, onAfterAdd, onClick } = this.props

      event.preventDefault()
      event.stopPropagation()

      if (isFetching) {
        return
      }

      this.setState({ isFetching: true })

      if (typeof onBeforeAdd === 'function') {
        onBeforeAdd(product, metadata)
      }

      if (typeof generateOnClick === 'function') {
        generateOnClick(this.props)
      }

      if (typeof onClick === 'function') {
        onClick(event)
      }

      action(product, metadata)
        .then((result) => {
          if (typeof onAfterAdd === 'function') {
            onAfterAdd(product, metadata, Boolean(result))
          }
        })
        .finally(() => this.setState({ isFetching: false }))
    }

    render() {
      const { isFetching } = this.state
      const { component, ...props } = this.props

      const Element = component || Button

      return (
        <Element
          {...props}
          loading={withLoading && isFetching}
          onClick={this.handleClick}
        />
      )
    }
  }

export default generateButton
